<template>
    <div>
      <!-- <PC v-if="type===0"></PC> -->
      <LearningReport></LearningReport>
    </div>
</template>
  
  <script>
//  import PC from '@/components/25JuneTest/PC.vue'
 import LearningReport from '@/components/25November/LearningReport.vue'
  export default {
    name: 'one',
    components:{
      LearningReport,
      // PC
    },
    data(){
      return{
        type:0,
        width:window.innerWidth
      }
    },
    // created(){
    //    var hscr=window.location.href
    //    if(this.width > 720) {
    //       this.type = 0
    //     } else if (this.width <= 720) {
    //       this.type = 1
    //     }
    // }
  }
  </script>
  
  <style>
  
  </style>
  